"use client";

import { useEffect } from "react";
import { captureException } from "@sentry/nextjs";
import { useRouter, useSearchParams } from "next/navigation";
import { apiAuthClient } from "services/apiAuthClient";
import useCustomToast from "utils/hooks/useCustomToast";
export const VerifiedEmailToastLogic = () => {
  const params = useSearchParams();
  const router = useRouter();
  const {
    customToast
  } = useCustomToast();
  useEffect(() => {
    const token = params?.get("token");
    if (!token) return;
    const verifyEmail = async () => {
      try {
        const encodedToken = encodeURIComponent(token);
        const res = await apiAuthClient.verifyEmailAddress({
          params: {
            token: encodedToken
          }
        });
        if (res?.data?.status === 200 || res?.data?.status === 201) {
          customToast({
            type: "success",
            title: "Welcome to Whimstay!",
            message: "You’re all set! Your email has been verified.",
            duration: 3000,
            className: "toast-anim !bottom-4 msm:!bottom-[unset] !left-[unset] !right-4 msm:!right-6 msm:!top-[64px]"
          });
        }
      } catch (err) {
        console.error(err);
        captureException(new Error(`Error 'verifyEmailAddress' ${JSON.stringify(err)}`));
      } finally {
        // Remove token from URL (clean URL)
        router.replace("/");
      }
    };
    void verifyEmail();
  }, []);
  return null;
};